import type {
  getProvidersQuery,
  InputMaybe,
  ProvidersOrderBy,
} from "../../remote/gql/graphql";
import type { ClientReturnType } from "../types";
import type { AlaffiaClientModuleArgs } from "./modules";

import { getProvidersQueryDoc } from "../../remote/queries/getProviders.gql";
import { AlaffiaClientModule } from "./modules";

type ProvidersModuleArgs = AlaffiaClientModuleArgs;

export class ProvidersModule extends AlaffiaClientModule {
  constructor(args: ProvidersModuleArgs) {
    super(args);
  }

  getProviders = async (input: {
    orderBy: InputMaybe<ProvidersOrderBy | ProvidersOrderBy[]>;
  }): ClientReturnType<getProvidersQuery["providers"]> => {
    const result = await this.runGqlQuery(
      getProvidersQueryDoc,
      { orderBy: input.orderBy },
      "getProviders",
    );
    return {
      data: result.data?.providers ?? null,
      error: result.error ?? null,
    };
  };
}
